<template>
    <div style="font-size: 1em">
        <br />
        <pre>📊 Account Analysis</pre>
        <div
            v-if="
                !!modalData['time_decay_chart'] &&
                !!modalData['toxic_time_decay']
            "
        >
            <pre>Time Decay</pre>
            <EChartDisplay
                :chartData="modalData['time_decay_chart'] || {}"
                :chartType="
                    modalData['time_decay_chart']['chart_type'] || 'line'
                "
                :chartHeight="250"
                chartName="Time Decay Chart"
                :isOpen="isOpen"
            />
        </div>
        <div
            v-if="
                !!modalData['scalping_metrics_all_history_table'] &&
                !!modalData['scalping_metrics_last_trading_day_table'] &&
                !!modalData['toxic_time_decay']
            "
        >
            <br />
            <pre>Scalping Behavior</pre>
            <v-tabs height="36">
                <v-tab @click="scalpingMode = 'all_history'">All History</v-tab>
                <v-tab @click="scalpingMode = 'last_trading_day'"
                    >Last Trading Day</v-tab
                >
            </v-tabs>
            <v-data-table
                :headers="scalpingMetricsHeaders"
                :items="
                    scalpingMode === 'all_history'
                        ? scalpingMetricsAllHistoryData
                        : scalpingMetricsLastDayData
                "
                class="elevation-1"
                hide-default-footer
            />
        </div>
        <div v-if="!!modalData['metrics_table']">
            <br />

            <pre>Key Metrics</pre>
            <v-data-table
                :headers="metricsHeader"
                :items="metricsData"
                class="elevation-1"
                hide-default-footer
            >
                <template v-slot:item.value="{ item }">
                    <template v-if="item.metric === 'Key Tags'">
                        <v-chip
                            v-for="(tag, i) in tagData"
                            :key="i"
                            class="ma-1"
                            color="primary"
                            x-small
                        >
                            {{ tag }}
                        </v-chip>
                    </template>

                    <template v-else>
                        {{ item.value }}
                    </template>
                </template>
            </v-data-table>
        </div>

        <div v-if="!!modalData['risk_summary']">
            <br />
            <pre class="mb-2">Summary</pre>
            <p
                style="white-space: pre-wrap; word-break: break-word"
                class="mb-0"
            >
                {{ modalData.risk_summary }}
            </p>
        </div>
    </div>
</template>
<script>
import { helper } from "@components/mixins/helper";
import EChartDisplay from "./EChartDisplay.vue";

export default {
    components: { EChartDisplay },
    mixins: [helper],
    props: {
        modalData: Object,
        isOpen: Boolean,
    },
    data() {
        return {
            metricsHeader: [
                { text: "Metric", value: "metric" },
                { text: "Value", value: "value" },
            ],
            scalpingMetricsHeaders: [
                { text: "Holding Time", value: "holding_time" },
                { text: "Trade Ratio", value: "trade_ratio" },
                { text: "Pnl", value: "pnl" },
            ],
            scalpingMode: "all_history",
        };
    },
    computed: {
        metricsData() {
            const result = [];
            for (const [key, value] of Object.entries(
                this.modalData["metrics_table"] || {}
            )) {
                result.push({
                    metric: key
                        .replaceAll("_", " ")
                        .replace(/\b\w/g, (c) => c.toUpperCase()),
                    value:
                        key === "win_rate"
                            ? (value * 100).toFixed(2) + "%"
                            : "$" + this.numberWithCommas(value.toFixed(2)),
                });
            }
            result.push({
                metric: "Key Tags",
                value: this.tagData,
            });
            return result;
        },
        scalpingMetricsAllHistoryData() {
            const result = [];

            for (const item of [
                "1_minute",
                "3_minute",
                "5_minute",
                "10_minute",
                "30_minute",
                "over_30_minutes",
            ]) {
                result.push({
                    holding_time: item.includes("over")
                        ? "> 30 mintutes"
                        : item === "1_minute"
                        ? "≤ 1 minute"
                        : "≤ " + item.replaceAll("_", " ") + "s",
                    trade_ratio:
                        (
                            this.modalData?.scalping_metrics_all_history_table
                                ?.count_ratios?.[item] * 100
                        ).toFixed(2) + "%" || "N/A",
                    pnl:
                        "$" +
                            this.numberWithCommas(
                                (this.modalData?.scalping_metrics_all_history_table?.scalping_pnl?.[
                                    item
                                ]).toFixed(2)
                            ) || "N/A",
                });
            }

            return result;
        },
        scalpingMetricsLastDayData() {
            const result = [];

            for (const item of [
                "1_minute",
                "3_minute",
                "5_minute",
                "10_minute",
                "30_minute",
                "over_30_minutes",
            ]) {
                result.push({
                    holding_time: item.includes("over")
                        ? "> 30 mintutes"
                        : item === "1_minute"
                        ? "≤ 1 minute"
                        : "≤ " + item.replaceAll("_", " ") + "s",
                    trade_ratio:
                        (
                            this.modalData
                                ?.scalping_metrics_last_trading_day_table
                                ?.count_ratios?.[item] * 100
                        ).toFixed(2) + "%" || "N/A",
                    pnl:
                        "$" +
                            this.numberWithCommas(
                                (this.modalData?.scalping_metrics_last_trading_day_table?.scalping_pnl?.[
                                    item
                                ]).toFixed(2)
                            ) || "N/A",
                });
            }

            return result;
        },
        tagData() {
            const result = [];

            for (const item of this.modalData?.tag?.split("\n") || []) {
                const parts = item.split(". ");
                if (parts.length === 2) {
                    result.push(parts[1].replaceAll("_", " "));
                }
            }

            return result;
        },
    },
    watch: {
        isOpen(nv) {
            if (nv) {
                this.sclpingMode = "all_history";
            }
        },
    },
};
</script>
